<template>
  <vx-card no-shadow>

    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Active</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="item" v-model="item.active"/>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-input v-if="item" label="" :content.sync="item.title" class="w-full" />
      </div>
    </div>

    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-textarea v-if="item" placeholder="Description..." :content.sync="item.description" class="w-full" />
      </div>
    </div>

    <h5 class="mb-3">Participation rules</h5>
    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Define the minimum score for the participant to pass the Venue Visit</span>
      </div>
      <div class="vx-col">
        <vs-input v-if="item" v-validate="'numeric'" name="requiredPerformanceScore" v-model="item.requiredPerformanceScore" />
        <div v-if="item" class="text-danger text-sm" v-show="errors.has('requiredPerformanceScore')">{{ errors.first('requiredPerformanceScore') }}</div>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Permissions</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
      <span>Tags</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips color="rgb(145, 32, 159)" placeholder="New Tag" v-model="tags">
          <vs-chip
            :key="tag"
            @click="removeTag(tag)"
            v-for="tag in tags" closable>
            {{ tag }}
          </vs-chip>
        </vs-chips>
        <p style="font-weight:600;font-size:85%;margin-top:8px;">
          User will see the Venue Visit when the country tag and at least one other tag matches the user tags. 
        </p>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <TypedSurveyImages v-if="item" 
      :item="item" 
      :assetUrl="'VenueVisit/' + this.surveyId + '?moduleId=0&lessonId=0'"
      style="width: 100%;" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>

const TypedSurveyImages = () => import("./../components/TypedSurveyImages.vue");

export default {
  components: {
    TypedSurveyImages
  },
  props: {
    item: Object
  },
  data () {
    return {
      tags: [],

      surveyId: '',
      name: ''
    }
  },
  methods: {
    removeTag (item) {
      this.tags.splice(this.tags.indexOf(item), 1)
    },

    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      this.item.tags = this.tags;

      const payload = {
        active: this.item.active,
        title: this.item.title,
        description: this.item.description,
        requiredPerformanceScore: parseInt(this.item.requiredPerformanceScore),
        tags: this.tags
      }

      this.$http.put(process.env.VUE_APP_API +'/Surveys/3/' + this.item.id + '/info/general/', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Venue Visit saved'
            });
          })
          .catch(err => {
            console.log(err);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save Venue Visit: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;

    if (this.item.tags) {
      this.tags = this.item.tags;
    } else {
      this.tags = [];
    }
  }
}
</script>
